import React from 'react';
import { Col, Radio, RadioGroup, Row, themes } from '@digitools/honest-react';
import useCliDataContext from '../../../hooks/useCliDataContext';
import AboutYourAbsenceText from 'src/packages/cli/constants/AboutYourAbsenceText';
import useTranslate from 'src/hooks/useTranslate';
import { Experience } from 'src/types/Experience';
import useExperience from 'src/hooks/useExperience';
const AccidentIndicator = (props) => {
    const { absenceData } = useCliDataContext();
    const { t } = useTranslate();
    const { experience } = useExperience();
    const { formLabels } = AboutYourAbsenceText;
    const accidentIndicatorLabel = experience === Experience.EMPLOYEE
        ? t(formLabels.accidentIndicator)
        : `${t(formLabels.accidentIndicator)} (optional)`;
    const accidentIndicatorShortLabel = experience === Experience.EMPLOYEE
        ? t(formLabels.accidentIndicatorShortLabel)
        : formLabels.accidentIndicatorShortLabel.english;
    return (<>
      <Row data-testid='accidentIndicator' className='mb-3'>
        <Col xs={12}>
          <RadioGroup label={accidentIndicatorLabel} semanticLabel={accidentIndicatorShortLabel} field={'accidentIndicator'} 
    // TODO: pending honest change to use existing optional label styling for optional
    // optional={experience === Experience.EMPLOYER}
    // language={language}
    legendStyles={{ marginBottom: '.5rem' }} theme={themes.rebrand} validateOnBlur={true} validateOnChange={true} isRequired={experience === Experience.EMPLOYEE} required={experience === Experience.EMPLOYEE} initialValue={absenceData && absenceData.accidentIndicator}>
            <Radio containerStyle={{ marginBottom: '.5rem' }} data-testid={'hi-yes'} key={'hi-yes'} name='accidentIndicator' label={t(AboutYourAbsenceText.formLabels.yes)} value={'Y'}/>
            <Radio containerStyle={{ marginBottom: '.5rem' }} data-testid={'hi-no'} key={'hi-no'} name='accidentIndicator' label={'No'} value={'N'}/>
          </RadioGroup>
        </Col>
      </Row>
    </>);
};
export default AccidentIndicator;
